import { getLocalStorage } from '@libs/storage';
import { generateUUID } from '@libs/uuid';

const STORAGE_KEY = 'device_id';
const MIN_LENGTH = 30;

export class DeviceIdService {
  private constructor() {
    const storage = getLocalStorage();
    let id = storage.getItem(STORAGE_KEY);

    if (!id || id.length < MIN_LENGTH) {
      id = generateUUID();
      storage.setItem(STORAGE_KEY, id);
    }

    this.id = id;
  }

  public id: string;

  // Statics

  static #instance: DeviceIdService;

  static get instance(): DeviceIdService {
    if (!this.#instance) {
      this.#instance = new DeviceIdService();
    }

    return this.#instance;
  }
}
